import {SedestralRouter} from "../../../sedestral/router/SedestralRouter";
import {NotFoundPage} from "../../panel/components/pages/global/notfound/NotFoundPage";
import {LoaderStatic} from "../../panel/components/static/loaders/LoaderStatic";
import {WebsitePricingPage} from "./pages/WebsitePricingPage";
import {WebsiteCgvPage} from "./pages/WebsiteCgvPage";
import {WebsiteCguPage} from "./pages/WebsiteCguPage";
import {WebsitePolicyPage} from "./pages/WebsitePolicyPage";
import {
    ISedestralRouterConfig
} from "../../../sedestral/router/types/ISedestralRouterConfig";
import {WebsiteSchedulePage} from "./pages/WebsiteSchedulePage";
import {WebsiteWritingPage} from "./pages/WebsiteWritingPage";
import {WebsiteAutopilotPage} from "./pages/WebsiteAutopilotPage";
import {WebsiteWixPage} from "./pages/WebsiteWixPage";
import {WebsiteShopifyPage} from "./pages/WebsiteShopifyPage";
import {WebsitePrestashopPage} from "./pages/WebsitePrestashopPage";
import {WebsiteWordpressPage} from "./pages/WebsiteWordpressPage";
import {WebsiteHomePage} from "./pages/WebsiteHomePage";
import {WebsiteAnalysisPage} from "./pages/WebsiteAnalysisPage";
import {WebsiteBlogPage} from "./pages/WebsiteBlogPage";
import {WebsiteGuidePage} from "./pages/WebsiteGuidePage";
import {WebsiteEditorPage} from "./pages/WebsiteEditorPage";
import {WebsiteTopicsPage} from "./pages/WebsiteTopicsPage";
import {WebsiteAuditStructurePage} from "./pages/WebsiteAuditStructurePage";
import {WebsiteAuditPage} from "./pages/WebsiteAuditPage";
import {WebsitePrestashopModulePage} from "./pages/WebsitePrestashopModulePage";
import {WebsiteTestimonialBetPage} from "./pages/WebsiteTestimonialBetPage";
import {WebsiteTestimonialRayssaPage} from "./pages/WebsiteTestimonialRayssaPage";
import {WebsiteWebflowPage} from "./pages/WebsiteWebflowPage";

export class WebsiteRouter extends SedestralRouter {
    async init(config?: ISedestralRouterConfig): Promise<void> {
        super.init(config);
        super.initStarted();
    }

    registerPages() {
        this.pages.registerPage("/blog", () => new WebsiteBlogPage());
        this.pages.registerPage("/schedule", () => new WebsiteSchedulePage());
        this.pages.registerPage("/404", () => new NotFoundPage());
        this.pages.registerPage("/home", () => new WebsiteHomePage());
        this.pages.registerPage("/pricing", () => new WebsitePricingPage());
        this.pages.registerPage("/cgv", () => new WebsiteCgvPage());
        this.pages.registerPage("/ai", () => new WebsiteWritingPage());
        this.pages.registerPage("/editor", () => new WebsiteEditorPage());
        this.pages.registerPage("/topics", () => new WebsiteTopicsPage());
        this.pages.registerPage("/autopilot", () => new WebsiteAutopilotPage());
        this.pages.registerPage("/analysis", () => new WebsiteAnalysisPage());
        this.pages.registerPage("/wix", () => new WebsiteWixPage());
        this.pages.registerPage("/webflow", () => new WebsiteWebflowPage());
        this.pages.registerPage("/wordpress", () => new WebsiteWordpressPage());
        this.pages.registerPage("/shopify", () => new WebsiteShopifyPage());
        this.pages.registerPage("/prestashop", () => new WebsitePrestashopModulePage());
        this.pages.registerPage("/prestashop", () => new WebsitePrestashopModulePage());
        this.pages.registerPage("/for-prestashop", () => new WebsitePrestashopPage());
        this.pages.registerPage("/cgu", () => new WebsiteCguPage());
        this.pages.registerPage("/policy", () => new WebsitePolicyPage());
        this.pages.registerPage("/guide", () => new WebsiteGuidePage());
        this.pages.registerPage("/guide", () => new WebsiteGuidePage());
        this.pages.registerPage("/structure-audit", () => new WebsiteAuditStructurePage());
        this.pages.registerPage("/content-audit", () => new WebsiteAuditPage());
        this.pages.registerPage("/testimonial/bet-thermique", () => new WebsiteTestimonialBetPage());
        this.pages.registerPage("/testimonial/rayssaguel", () => new WebsiteTestimonialRayssaPage());

        this.pages.path404 = "/404";
        this.pages.pathHome = "/home";
        this.pages.pathLogin = "/home";
    }

    registerStatic() {
        this.static.register("loader", new LoaderStatic());
    }

    onLogin() {
        this.pages.redirect(this.pages.pathHome);
    }

    onLogout() {
        setTimeout(() => {
            this.pages.redirect(this.pages.pathLogin);
        }, 3000);
    }
}